import { Component, OnInit } from '@angular/core';
import { forEach, orderBy } from 'lodash';
import { ReleaseNotesService, ReleaseNote } from '@app/shared/services/api/release-notes.service';
import { map } from 'rxjs/operators';
import { OverlayLoaderService } from '@app/shared/services/overlay-loader.service';

@Component({
  selector: 'app-release-note-admin',
  templateUrl: './release-note-admin.component.html',
  styleUrls: ['./release-note-admin.component.scss'],
})
export class ReleaseNoteAdminComponent implements OnInit {
  releaseNotes: ReleaseNoteExtended[] = [];

  constructor(
    private releaseNotesService: ReleaseNotesService,
    private overlayLoaderService: OverlayLoaderService,
  ) {}

  ngOnInit() {
    this.onRefreshList();
  }

  onEdit(data: ReleaseNoteExtended) {
    this.releaseNotesService.activeReleaseNote = data;
  }

  onAdd() {
    this.releaseNotesService.activeReleaseNote = null;
  }

  onRefreshList() {
    this.overlayLoaderService.isLoading = true;

    this.releaseNotesService
      .get()
      .pipe(
        map((data: ReleaseNote[]) => {
          forEach(data, (item: { [key: string]: any }) => (item['notesList'] = item.notes.split('\n')));
          return data;
        }),
      )
      .subscribe((data) => {
        this.releaseNotes = orderBy(data, ['releaseDate'], ['desc']);
        this.overlayLoaderService.isLoading = false;
      });
  }
}

export interface ReleaseNoteExtended extends ReleaseNote {
  isEditing?: boolean;
}
